import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/vercel/path0/src/app/(landing)/i18n.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandingContent"] */ "/vercel/path0/src/app/(landing)/LandingContent.tsx");
